import { render } from "./CancelStart.vue?vue&type=template&id=6d318bbd"
import script from "./CancelStart.vue?vue&type=script&lang=js"
export * from "./CancelStart.vue?vue&type=script&lang=js"
script.render = render

export default script